import React, {createContext, useEffect, useState} from "react";
import {light, dark } from "../assets/themes";

type ThemeContextValue = {
  isDark: boolean
}

const rs = document.documentElement.style;

export const ThemeContext = createContext<ThemeContextValue>({
  isDark: true
});

export const ThemeContextProvider = ({children}: {children: React.ReactNode}) => {
  
  const [isDark, setIsDark] = useState(true);
  
  window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', event => {
    setIsDark(event.matches);
  });
  
  const theme = isDark ? dark : light;

  //theme specific
  useEffect(() => {
    rs.setProperty('--colour-body-base', theme.body);
    rs.setProperty('--colour-text-base', theme.text);
    rs.setProperty('--colour-line-base', theme.text);
    rs.setProperty('--colour-text-secondary-base', theme.textSecondary);
    rs.setProperty('--colour-element-base', theme.element);
    rs.setProperty('--colour-element-text-base', theme.elementText);
    rs.setProperty('--colour-element-subtle-base', theme.elementSubtle);
    rs.setProperty('--colour-subtle-base', theme.subtle);
    rs.setProperty('--colour-disabled', theme.disabled);
    rs.setProperty('--colour-overlay', theme.overlay);
  }, [isDark]);

  //constants
  useEffect(() => {
    rs.setProperty('--colour-body-blackout-constant', light.body);
    rs.setProperty('--colour-text-blackout-constant', light.text);
    rs.setProperty('--colour-line-blackout-constant', light.text);
    rs.setProperty('--colour-text-secondary-blackout-constant', light.textSecondary);
    rs.setProperty('--colour-element-blackout-constant', light.element);
    rs.setProperty('--colour-element-text-blackout-constant', light.elementText);
    rs.setProperty('--colour-element-subtle-blackout-constant', light.elementSubtle);
    rs.setProperty('--colour-subtle-blackout-constant', light.subtle);
    rs.setProperty('--colour-overlay-light', dark.overlay);
    rs.setProperty('--colour-overlay-dark', light.overlay);
    rs.setProperty('--colour-overlay-darker', light.overlayDarker);
  }, []);
  
  return (
    <ThemeContext.Provider value={{
      isDark
    }}>
      {children}
    </ThemeContext.Provider>
  )
}